import { z } from "zod";
import { validateUsPhoneNumberInput } from "./utils/validateUsPhoneNumberInput";

export const editTeamMemberSchema = z.object({
  firstName: z.string().min(1, { message: "First Name must not be empty" }),
  lastName: z.string().min(1, { message: "Last Name must not be empty" }),
  email: z.string().email().min(1, { message: "Email must not be empty" }),
  designation: z.string().optional(),
  phone: z.string().optional().refine(validateUsPhoneNumberInput, {
    message: "Please enter a valid 10 digit mobile number.",
  }),
  workplacePhone: z.string().optional().refine(validateUsPhoneNumberInput, {
    message: "Please enter a valid 10 digit landline number.",
  }),
  roles: z.string(),
  permissions: z.array(z.string()).optional(),
});

export type EditTeamMemberSchema = z.infer<typeof editTeamMemberSchema>;
